import { MerchandisingDetail } from "../types/ContentfulTypes";
import CartClient, { CartItemModel, CartItemSelectedAttribute } from "./CartClient";

export default class CartService {
  async addToCart(
    coreProductId: string,
    productName: string,
    productVersion: number,
    merchandisingDetail: MerchandisingDetail | undefined,
    fullSelections: Record<string, string>,
    availableQuantities: number[],
    selectedQuantity: number,
    previewImageUrl: string,
    locale: string,
    shopperId: string,
    authorizationHeader: string,
    vistacartTenant: string
  ) {
    const selections = Object.entries(fullSelections).reduce(
      (
        result: CartItemSelectedAttribute[],
        [property, option]: [string, string]
      ): CartItemSelectedAttribute[] => {
        let merchandisingDetailProperty, merchandisingDetailOption;
        if (merchandisingDetail && merchandisingDetail.properties) {
          merchandisingDetailProperty = merchandisingDetail.properties.find(
            p => p.key === property
          );
          if (merchandisingDetailProperty && merchandisingDetailProperty.options) {
            // Use option name when the option only maps to one core model mapping.
            merchandisingDetailOption = merchandisingDetailProperty.options.find(
              o =>
                Object.keys(o.coreModelMappings).length === 1 &&
                Object.keys(o.coreModelMappings).includes(property) &&
                o.coreModelMappings[`${property}`] === option
            );
          }
        }

        const selection = {
          key: property,
          value: option,
          keyDisplayName: merchandisingDetailProperty?.name,
          valueDisplayName: merchandisingDetailOption?.name ?? option,
        };

        result.push(selection);

        return result;
      },
      []
    );

    const options = {
      shopperId,
      locale,
      authorizationHeader,
      vistacartTenant,
    };

    const cartLineItem: CartItemModel = {
      design: {
        livePreviewUrl: previewImageUrl,
      },
      merchandisableQuantities: {
        list: availableQuantities,
      },
      product: {
        productKey: coreProductId,
        productVersion: productVersion,
        productDisplayName: productName,
        selectedAttributes: selections,
      },
      quantity: selectedQuantity,
    };

    const client = new CartClient();
    await client.addToCart([cartLineItem], options);
  }
}
